var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.analysisTemplate.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.analysisTemplate.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: () => `${this.url}`
      },
      list: {
        path: () => `${this.path}${ROUTES.analysisTemplate.list.match.path}`,
        url: () => {
          return `${this.url}${ROUTES.analysisTemplate.list.location.pathname}`;
        }
      },
      create: {
        path: () => `${this.path}${ROUTES.analysisTemplate.create.match.path}`,
        url: () => {
          return `${this.url}${ROUTES.analysisTemplate.create.location.pathname}/create`;
        }
      },
      view: {
        path: () => `${this.path}${ROUTES.analysisTemplate.view.match.path}`,
        url: (payload) => {
          const { templateName } = payload;
          return `${this.url}${ROUTES.analysisTemplate.view.location.pathname}/template/${templateName}`;
        }
      },
      dataSource: {
        path: () => `${this.path}${ROUTES.analysisTemplate.dataSource.match.path}`,
        url: () => {
          return `${this.url}${ROUTES.analysisTemplate.dataSource.location.pathname}/data-source`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const AnalysisTemplateRouteUtils = new Util();
export {
  AnalysisTemplateRouteUtils
};
//# sourceMappingURL=AnalysisTemplateRoute.utils.js.map
